import axios from "axios";
import { APIURL } from "../utilities/api";
import { deleteCookie, getCookie } from "../utilities/utll";

export const TOKEN_KEY = "CARREFOUR_JWT";

const api = axios.create({
  baseURL: APIURL,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request Interceptor: Attach Token
api.interceptors.request.use(
  async (config) => {
    try {
      const token = getCookie("token");
      if (token) {
        config.headers.Authorization = token;
      }
    } catch (error) {
      console.error("Error retrieving token:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or invalid
      try {
        deleteCookie("auth");
        deleteCookie("userDetail");
        deleteCookie("token");

        setTimeout(() => {
          window.location.href = "/login";
        }, 800);
        // Ideally, trigger a logout action in AuthContext via an event emitter or navigation reset
        // For now, we just clear storage. AuthContext check on app resume/start will handle state.
      } catch (storageError) {
        console.error("Error clearing token on 401:", storageError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
